module.exports = __webpack_public_path__ + "img/clock.93578c44.png";